import { Title } from "@justhome/react-ui";
import { useApplicationTranslation } from "@lib/hooks/translations";
import OpInForm, {
  OptInFormData,
} from "@modules/application/components/OptInForm";
import Image from "next/image";
import { FC } from "react";
import { DeepPartial } from "react-hook-form";
import { OptInType } from "../../../components/OptInForm/types";

const OptInComponent: FC<{
  optInType: OptInType;
  defaultValues?: DeepPartial<OptInFormData>;
  onSubmit: (form: OptInFormData) => void;
  isLoading: boolean;
  isError: boolean;
}> = ({ onSubmit, optInType, defaultValues, isLoading, isError }) => {
  const { t } = useApplicationTranslation();

  const isBefore = optInType === "before";

  return (
    <section className="flex flex-col-reverse m:grid grid-cols-12 gap-xl">
      <div className="col-span-6">
        <div>
          <Title>
            {isBefore
              ? t("opt_in_before_form_title")
              : t("opt_in_after_form_title")}
          </Title>
          <p className="text-neutral-575 text-body-1 m:max-w-[564px] mt-3s">
            {isBefore
              ? t("opt_in_before_form_sub_title")
              : t("opt_in_after_form_sub_title")}
          </p>
        </div>
        <OpInForm
          defaultValues={defaultValues}
          onSubmit={onSubmit}
          optInType={optInType}
          isLoading={isLoading}
          isError={isError}
        />
      </div>
      <div className="col-span-6 mb-3s m:mb-none mt-xl m:mt-none hidden m:flex items-center">
        <Image
          src="https://cdn.justhome.com/cdn/assets/opt_in_image_cc8cf6a494.png"
          alt=""
          width="721"
          height="512"
          className="max-w-[160px] m:max-w-none"
        />
      </div>
    </section>
  );
};

export default OptInComponent;
